import { ArticleParagraph1, ArticleParagraph2 } from '@cian/ui-kit';

import { FC } from 'react';

import { IOperatorInfoProps } from './types';

import * as styles from './OperatorInfo.css';

export const OperatorInfo: FC<IOperatorInfoProps> = props => {
  const { name, type } = props;

  return (
    <div className={styles['container']}>
      <ArticleParagraph1 as="span" color="black_100" fontWeight="normal">
        {name}
      </ArticleParagraph1>
      <div className={styles['user-type-container']}>
        <ArticleParagraph2 as="span" color="gray60_100" fontWeight="normal">
          {type}
        </ArticleParagraph2>
      </div>
    </div>
  );
};

OperatorInfo.displayName = 'OperatorInfo';
